console.log("hello here");


jQuery(document).ready(function() {
	console.log("test header");


		jQuery('.list-social__item a').attr("target","_blank");
		jQuery('.custom-review-content .rating').attr("aria-label","5 Star Rating");


		//jQuery('.custom-features-icon img, .custom-icon-text-icon img, .custom-buy-button img, .footer-stripe-box img').attr("alt","");
		jQuery('.custom-buy-button img').attr("aria-hidden","true");
		jQuery('.custom-review-avatar').attr("role","img");
		jQuery('.custom-review-avatar').attr("aria-label","Baby sitting on a chair");
		jQuery('.jdgm-widget-actions-wrapper a').attr("aria-haspopup","dialog");
		jQuery('.jdgm-widget-actions-wrapper a').removeAttr("aria-expanded");
		jQuery('.footer-block__brand-info a').attr("aria-label","Email Address: support@cocoseat.com, opens email application");
		jQuery('br').attr("aria-hidden","true");
		jQuery('.card__heading.h2').attr("aria-level","2");
		jQuery('.babylist-wrapper img').attr("alt","Baby list logo");

        

        jQuery('.decorated-link').first().parent().html(
                'If you have questions about your shipment, contact support ' +
                '<a href="mailto:support@cocoseat.com" class="decorated-link cursor-pointer">support@cocoseat.com</a>'
            );

         jQuery('.shopify-policy__container').html(function (_, html) {
        return html.replace(
            /support@cocoseat\.com/g,
            '<a href="mailto:support@cocoseat.com">support@cocoseat.com</a>'
        );
    });


	jQuery('a[href="https://www.facebook.com/coco.comfy/"]').attr('aria-label', "Facebook, opens in new tab");
	jQuery('a[href="https://www.pinterest.com/coco_comfort/"]').attr('aria-label', "Pinterest, opens in new tab");
	jQuery('a[href="https://www.instagram.com/the.coco.brand/"]').attr('aria-label', "Instagram, opens in new tab");
	jQuery('a[href="https://www.tiktok.com/@coco.seat"]').attr('aria-label', "Tiktok, opens in new tab");
	jQuery('a[href="tel:+17256005722"]').attr('aria-label', "Phone Number: +1 725 6005722");
	jQuery('a[href="mailto:support@cocoseat.com"]').attr('aria-label', "Email Address: support@cocoseat.com, opens email application");
	jQuery('a[href="mailto:info@cocoseat.com"]').attr('aria-label', "Email Address: info@cocoseat.com, opens email application");
 
	jQuery('input[name="order"]').attr('aria-label', "Order number");
	jQuery('input[name="email"]').attr('aria-label', "Email or Phone Number");
	jQuery('input[name="nums"]').attr('aria-label', "Tracking Number");
 

	jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
   	jQuery('a .icon-yelp').parent('a').attr('aria-label', "Visit Benny's Tacos on Yelp (opens in new tab)");



       });


// ========================================================== BUG 5 ========================================================


$(document).ready(function () {

  // Fix 1: Broken aria-labels on thumbnail buttons
  $('.bobby-gallery-thumbs .bobby-thumb').each(function (i) {
    var $btn = $(this);
    var alt  = $btn.find('img').attr('alt') || '';

    // Replace broken translation key with simple positional label
    var label = alt && !/translation missing/i.test(alt)
      ? 'View image ' + (i + 1) + ': ' + alt
      : 'View image ' + (i + 1);

    $btn.attr('aria-label', label);

    // Fix 2: Make thumbnails keyboard focusable and operable
    $btn.attr('tabindex', '0');

    $btn.on('keydown', function (e) {
      // Enter or Space activates the button (native button should handle this,
      // but bobby sometimes suppresses it)
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
  });

});

// ========================================================== BUG 6 ========================================================
$(function () {

    $('.rating-wrapper').each(function () {
        const ratingText = $(this).find('.custom-rating-text').text().trim();

        if (!ratingText) return;

        $(this)
            .find('.rating[role="img"]')
            .attr('aria-label', `Rating: ${ratingText}`);
    });

});


// ========================================================== BUG 8 ========================================================

$(document).ready(function () {

  $('.custom-price-container').each(function () {
    var $container  = $(this);
    var $saleWrap   = $container.find('.custom-price-formatted');
    var $compareAt  = $container.find('.custom-price-compare-at del');
    var $discount   = $container.find('.custom-price-discount span');

    // --- Build sale price string ---
    var saleCurrency = $saleWrap.find('.currency').text().trim();
    var saleInteger  = $saleWrap.find('.integer').text().trim();

    // --- Build compare-at (regular) price string ---
    var regCurrency  = $compareAt.find('.currency').text().trim();
    var regAmount    = $compareAt.find('span:not(.currency)').text().trim();

    // --- Apply aria-labels ---
    if (saleInteger) {
      $saleWrap.attr('aria-label', 'Sale price: ' + saleCurrency + saleInteger);
    }

    if (regAmount) {
      // aria-label overrides the default <del> announcement ("deleted text")
      $compareAt.attr('aria-label', 'Regular price: ' + regCurrency + regAmount);
    }

    if ($discount.length) {
      $discount.attr('aria-label', 'Discount: ' + $discount.text().trim() + ' off');
    }

  });

});
// ========================================================== BUG 8 ========================================================

$(document).ready(function () {

  var $success = $('#Newsletter-success--template--30325068235097__newsletter_zdNHNG');

  // If success message is in the DOM and visible, move focus to it
  if ($success.length && $success.is(':visible')) {
    $success.focus();
  }

});

// ========================================================== BUG 35 ========================================================

$(function () {
    $('.shopify-policy__container a').each(function () {
        $(this)
            .attr('target', '_blank')
            .attr('rel', 'noopener noreferrer');

        if (!$(this).find('.sr-only').length) {
            $(this).append(
                '<span class="sr-only"> (opens in a new tab)</span>'
            );
        }
    });
});

// ========================================================== BUG 35 ========================================================

$(function () {

    // Add required to the order input
    $('input[name="order_number"], #order_number').attr({
        required: true,
        'aria-required': 'true'
    });

    // IP - SPEED OPTIMIZATION - INTERATION 1: initialize existing alerts once, then inspect only relevant mutations.
    function initTrackingAlerts(root = document) {
        $(root).find('.pp_tracking_alert').each(function () {

            if (!$(this).attr('role')) {
                $(this).attr({
                    role: 'alert',
                    'aria-live': 'assertive'
                });
            }

        });
    }
    initTrackingAlerts();

    // IP - SPEED OPTIMIZATION - INTERATION 5: ParcelPanel renders this mount
    // before its async app. Observe the widget wherever it is embedded, rather
    // than every app mutation on pages without a tracking widget.
    const trackingRoot = document.getElementById('pp-tracking-page-app');
    if (!trackingRoot) return;

    const observer = new MutationObserver(function (records) {
        const hasNewAlert = records.some(record => Array.from(record.addedNodes).some(node =>
            node.nodeType === 1 && (node.matches('.pp_tracking_alert') || node.querySelector('.pp_tracking_alert'))
        ));
        if (hasNewAlert) initTrackingAlerts(trackingRoot);
    });

    observer.observe(trackingRoot, {
        childList: true,
        subtree: true
    });

});


// ========================================================== BUG 17 ========================================================

$(function () {

    let trigger = $('.jdgm-write-rev-link');

    function initReviewModal() {
        const $modal = $('.jdgm-write-review-modal:visible');

        if (!$modal.length || $modal.data('a11y-init')) {
            return;
        }

        const focusable =
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

        const $focusable = $modal.find(focusable).filter(':visible');
        const first = $focusable.first()[0];
        const last = $focusable.last()[0];

        // A modal shell can arrive before its async form. Its scoped observer
        // will retry when controls are inserted.
        if (!first) return;
        $modal.data('a11y-init', true);

        // Move focus into dialog
        if (first) {
            first.focus();
        }

        // Focus trap
        $modal.on('keydown.a11y', function (e) {

            if (e.key === 'Escape') {
                $('.jdgm-write-review-modal__close-btn, .jdgm-write-review-modal__nav-btn-close')
                    .first()
                    .trigger('click');

                trigger.focus();
            }

            if (e.key === 'Tab') {

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }

                if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });
    }

    // IP - SPEED OPTIMIZATION - INTERATION 5: existing dialogs have their own
    // observer. Discover a body-appended async dialog only after a review is
    // requested, before the app's click handler can create it.
    const watchedModals = new WeakSet();
    const modalObserver = new MutationObserver(watchReviewModals);
    const discoveryObserver = new MutationObserver(function (records) {
        const reviewChanged = records.some(record =>
            (record.target.nodeType === 1 &&
                (record.target.closest('.jdgm-write-review-modal') || record.target.querySelector('.jdgm-write-review-modal'))) ||
            Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
                (node.matches('.jdgm-write-review-modal') || node.querySelector('.jdgm-write-review-modal')))
        );
        if (reviewChanged) watchReviewModals();
    });
    // IP - SPEED OPTIMIZATION - INTERATION 5: a failed app load must not leave
    // body-wide discovery running forever. Each later click starts a new window.
    let discoveryTimeout;
    function stopReviewDiscovery() {
        discoveryObserver.disconnect();
        clearTimeout(discoveryTimeout);
        discoveryTimeout = undefined;
    }
    window.addEventListener('pagehide', stopReviewDiscovery);

    function watchReviewModals() {
        document.querySelectorAll('.jdgm-write-review-modal').forEach(modal => {
            if (watchedModals.has(modal)) return;
            watchedModals.add(modal);
            modalObserver.observe(modal, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'hidden']
            });
        });
        initReviewModal();
        if ($('.jdgm-write-review-modal:visible').length) stopReviewDiscovery();
    }

    watchReviewModals();
    document.addEventListener('click', function (event) {
        const reviewTrigger = event.target.closest?.('.jdgm-write-rev-link');
        if (!reviewTrigger) return;
        trigger = $(reviewTrigger);
        stopReviewDiscovery();
        discoveryObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden']
        });
        discoveryTimeout = setTimeout(stopReviewDiscovery, 30000);
        watchReviewModals();
    }, true);

    // Return focus when modal closes
    $(document).on(
        'click',
        '.jdgm-write-review-modal__close-btn, .jdgm-write-review-modal__nav-btn-close, .jdgm-write-review-modal__overlay',
        function () {
            setTimeout(function () {
                trigger.focus();
            }, 100);
        }
    );

});
